import { SVGProps } from 'react';

const SvgBankInstant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 9.5H4v7h2zM12 9.5h-2v7h2zM21 5.5l-10-5-10 5v2h20zM1 18.5v2h12.07c.1 0 1.14-2 1.14-2zM18 11.809V9.5h-2v5.853zM18.83 24h-.665l.664-4.667H16s2.444-4.306 4.157-7.333h.665l-.665 4.667H23z"
    />
  </svg>
);
export default SvgBankInstant;
